<!-- Dashboard Header -->
<div class="mb-8">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-gray-900">Dashboard</h1>
      <p class="text-gray-600 mt-1">Bienvenido al panel de control de CrediTotal</p>
    </div>
    <div class="flex items-center space-x-4">
      <div class="text-right">
        <p class="text-sm text-gray-500">Última actualización</p>
        <p class="text-sm font-medium text-gray-900">{{getCurrentTime()}}</p>
      </div>
      <div class="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center">
        <i class="fas fa-chart-line text-white text-lg"></i>
      </div>
    </div>
  </div>
</div>

<!-- Stats Cards -->
<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">

  <!-- Total Contactos -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between">
      <div>
        <p class="text-sm font-medium text-gray-500">Total Contactos</p>
        <p class="text-2xl font-bold text-gray-900">1,234</p>
        <p class="text-sm text-green-600 mt-1">
          <i class="fas fa-arrow-up mr-1"></i>
          +12% vs mes anterior
        </p>
      </div>
      <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
        <i class="fas fa-users text-blue-600 text-xl"></i>
      </div>
    </div>
  </div>

  <!-- Créditos Activos -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between">
      <div>
        <p class="text-sm font-medium text-gray-500">Créditos Activos</p>
        <p class="text-2xl font-bold text-gray-900">856</p>
        <p class="text-sm text-green-600 mt-1">
          <i class="fas fa-arrow-up mr-1"></i>
          +8% vs mes anterior
        </p>
      </div>
      <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
        <i class="fas fa-credit-card text-green-600 text-xl"></i>
      </div>
    </div>
  </div>

  <!-- Monto Total -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between">
      <div>
        <p class="text-sm font-medium text-gray-500">Monto Total</p>
        <p class="text-2xl font-bold text-gray-900">$2.4M</p>
        <p class="text-sm text-green-600 mt-1">
          <i class="fas fa-arrow-up mr-1"></i>
          +15% vs mes anterior
        </p>
      </div>
      <div class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
        <i class="fas fa-dollar-sign text-purple-600 text-xl"></i>
      </div>
    </div>
  </div>

  <!-- Tasa de Aprobación -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow">
    <div class="flex items-center justify-between">
      <div>
        <p class="text-sm font-medium text-gray-500">Tasa de Aprobación</p>
        <p class="text-2xl font-bold text-gray-900">87%</p>
        <p class="text-sm text-red-600 mt-1">
          <i class="fas fa-arrow-down mr-1"></i>
          -2% vs mes anterior
        </p>
      </div>
      <div class="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
        <i class="fas fa-percentage text-orange-600 text-xl"></i>
      </div>
    </div>
  </div>

</div>

<!-- Quick Actions -->
<div class="mb-8">
  <h2 class="text-xl font-semibold text-gray-900 mb-4">Acciones Rápidas</h2>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

    <!-- Nuevo Contacto -->
    <a [routerLink]="['/console/create-constacts']"
       class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md hover:border-blue-300 transition-all cursor-pointer group">
      <div class="flex items-center space-x-4">
        <div class="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center group-hover:bg-blue-200 transition-colors">
          <i class="fas fa-user-plus text-blue-600 text-xl"></i>
        </div>
        <div>
          <h3 class="font-medium text-gray-900">Nuevo Contacto</h3>
          <p class="text-sm text-gray-500">Agregar nuevo cliente</p>
        </div>
      </div>
    </a>

    <!-- Gestión Financiera -->
    <a [routerLink]="['/console/finacial-dashboard']"
       class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md hover:border-green-300 transition-all cursor-pointer group">
      <div class="flex items-center space-x-4">
        <div class="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center group-hover:bg-green-200 transition-colors">
          <i class="fas fa-piggy-bank text-green-600 text-xl"></i>
        </div>
        <div>
          <h3 class="font-medium text-gray-900">Gestión Financiera</h3>
          <p class="text-sm text-gray-500">Panel de finanzas</p>
        </div>
      </div>
    </a>

    <!-- Consola Admin -->
    <a [routerLink]="['/console/credit-option']"
       class="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md hover:border-purple-300 transition-all cursor-pointer group">
      <div class="flex items-center space-x-4">
        <div class="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center group-hover:bg-purple-200 transition-colors">
          <i class="fas fa-terminal text-purple-600 text-xl"></i>
        </div>
        <div>
          <h3 class="font-medium text-gray-900">Consola Admin</h3>
          <p class="text-sm text-gray-500">Configuración avanzada</p>
        </div>
      </div>
    </a>

  </div>
            </div>

<!-- Recent Activity -->
<div class="grid grid-cols-1 lg:grid-cols-2 gap-8">

  <!-- Activity Feed -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200">
    <div class="p-6 border-b border-gray-200">
      <h3 class="text-lg font-semibold text-gray-900">Actividad Reciente</h3>
    </div>
    <div class="p-6">
      <div class="space-y-4">

        <div class="flex items-start space-x-3">
          <div class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
            <i class="fas fa-user text-blue-600 text-sm"></i>
          </div>
          <div class="flex-1">
            <p class="text-sm text-gray-900">Nuevo contacto registrado</p>
            <p class="text-xs text-gray-500">Juan Pérez - hace 2 horas</p>
          </div>
                </div>

        <div class="flex items-start space-x-3">
          <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
            <i class="fas fa-check text-green-600 text-sm"></i>
          </div>
          <div class="flex-1">
            <p class="text-sm text-gray-900">Crédito aprobado</p>
            <p class="text-xs text-gray-500">María García - $50,000 - hace 4 horas</p>
          </div>
                </div>

        <div class="flex items-start space-x-3">
          <div class="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
            <i class="fas fa-clock text-yellow-600 text-sm"></i>
          </div>
          <div class="flex-1">
            <p class="text-sm text-gray-900">Solicitud pendiente</p>
            <p class="text-xs text-gray-500">Carlos López - hace 6 horas</p>
          </div>
                </div>

        <div class="flex items-start space-x-3">
          <div class="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
            <i class="fas fa-money-bill text-purple-600 text-sm"></i>
          </div>
          <div class="flex-1">
            <p class="text-sm text-gray-900">Pago recibido</p>
            <p class="text-xs text-gray-500">Ana Rodríguez - $15,000 - hace 1 día</p>
            </div>
        </div>

      </div>
    </div>
  </div>

  <!-- Quick Stats -->
  <div class="bg-white rounded-lg shadow-sm border border-gray-200">
    <div class="p-6 border-b border-gray-200">
      <h3 class="text-lg font-semibold text-gray-900">Estadísticas del Día</h3>
    </div>
    <div class="p-6">
      <div class="space-y-6">

        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
              <i class="fas fa-users text-blue-600 text-sm"></i>
            </div>
            <span class="text-sm font-medium text-gray-900">Nuevos Contactos</span>
          </div>
          <div class="text-right">
            <p class="text-lg font-semibold text-gray-900">24</p>
            <p class="text-xs text-green-600">+12%</p>
          </div>
                </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
              <i class="fas fa-check text-green-600 text-sm"></i>
            </div>
            <span class="text-sm font-medium text-gray-900">Aprobaciones</span>
          </div>
          <div class="text-right">
            <p class="text-lg font-semibold text-gray-900">18</p>
            <p class="text-xs text-green-600">+8%</p>
          </div>
                </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
              <i class="fas fa-clock text-yellow-600 text-sm"></i>
            </div>
            <span class="text-sm font-medium text-gray-900">Pendientes</span>
          </div>
          <div class="text-right">
            <p class="text-lg font-semibold text-gray-900">6</p>
            <p class="text-xs text-yellow-600">-2%</p>
          </div>
                </div>

        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
              <i class="fas fa-dollar-sign text-purple-600 text-sm"></i>
            </div>
            <span class="text-sm font-medium text-gray-900">Ingresos Hoy</span>
          </div>
          <div class="text-right">
            <p class="text-lg font-semibold text-gray-900">$125K</p>
            <p class="text-xs text-green-600">+15%</p>
            </div>
        </div>

      </div>
    </div>
  </div>

</div>